import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-120338f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"text-align":"center"} }
const _hoisted_2 = { class: "img-prew-item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "abs",
  style: {"bottom":"10px","right":"20px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-dianjishangchuan" }, null, -1))
const _hoisted_6 = { style: {"font-size":"14px","color":"#999","margin-top":"10px"} }

import { reactive, ref, watch, toRaw } from 'vue'
import { Delete, Plus, Edit } from '@element-plus/icons-vue'
import { getSign } from '@/apis/oss'
import useFileUtils from '@/util/useFileUtils'
import { uid } from 'uid/dist/index.js'
import { t } from '@/plugins/i18n'
import {
  ElMessage
} from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  imageRatio: {
    type: Number,
    default: 0
  },
  limit: {
    type: Number,
    default: 5
  },
  limitFile: {
    type: Object,
    default: () => ({
      accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG',
      beforeUpload: (file: any) => {
        const { getExtension } = useFileUtils()
        const ext = getExtension(file.name)
        const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG']
        console.log(ext)
        if (!limitList.includes(ext)) {
          ElMessage.warning(
            '上传文件只能是.jpg,.jpeg,.png,.JPG,.JPEG,.PNG格式'
          )
          return false
        }
        const size = file.size / 1024 / 1024
        if (size > 50) {
          ElMessage.warning('文件大小不超过50m')
          return false
        }
        return true
      }
    })
  },
  urlList: {
    type: Array,
    default: () => []
  },
  rotate: {
    type: Boolean,
    default: false
  }
},
  emits: ['change', 'update:urlList', 'edit'],
  setup(__props, { emit }) {

const props = __props


const { getExtension } = useFileUtils()
const host = ref('')
const uploadParams = reactive({
  name: '',
  key: '',
  policy: '',
  OSSAccessKeyId: '',
  success_action_status: 200,
  signature: ''
})

const urlList = (props.urlList || []).map((e: any) => ({ name: e, url: e }))
const fileList = ref(urlList)

watch(
  () => props.urlList,
  (newValue: any) => {
    const urlList = (newValue || []).map((e: any) => ({ name: e, url: e }))
    fileList.value = urlList
  }
)

const beforeUpload = (file: any) => {
  if (props.limitFile?.beforeUpload(file)) {
    return getOssSign(file)
  }
  return false
}

const handleChange = () => {
  const list = toRaw(fileList.value)
  emit(
    'update:urlList',
    list.map((e: any) => {
      if (e?.raw?.url) {
        return e.raw.url
      } else {
        return e.url
      }
    })
  )
  emit('change', fileList.value[0])
}

/**
 * 获取阿里云上传签名等参数
 */
const getOssSign = (file: any) => {
  return new Promise((resolve: any, reject: any): any => {
    getSign()
      .then((res: any) => {
        const data = res.data
        uploadParams.name = file.name
        uploadParams.key = `${data.dir}${uid()}`
        const ext = getExtension(file.name)
        if (ext && ext.length > 0) {
          uploadParams.key = `${uploadParams.key}.${ext}`
        }
        uploadParams.policy = data.policy
        uploadParams.OSSAccessKeyId = data.accessId
        uploadParams.signature = data.signature

        host.value = data.host.replace(/http[s]?:/, location.protocol)
        // this.customDomain = data.customDomain
        // // 上传后文件的访问url
        // file.url = `${this.customDomain}/${this.uploadParams.key}`
        console.log(`${data.customDomain}/${uploadParams.key}`)
        file.url = `${data.customDomain}/${uploadParams.key}`
        resolve(true)
      })
      .catch((error) => {
        console.error('error', error)
        reject(new Error())
      })
      .finally(() => {
        // do nothing
      })
  })
}

const handleRemove = (file: any) => {
  console.log(file.url)
  fileList.value = fileList.value.filter((item: any) => {
    return item.url !== file.url
  })
  handleChange()
}


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (item, index) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "img-prew-content",
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            class: _normalizeClass(["el-upload-list__item-thumbnail", {normal:!__props.imageRatio,width100:__props.imageRatio===2,height100:__props.imageRatio===1}]),
            src: item.url,
            alt: ""
          }, null, 10, _hoisted_3),
          _createElementVNode("span", {
            class: _normalizeClass(["el-upload-list__item-actions", [{'active':__props.rotate}]])
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_el_icon, {
                onClick: ($event: any) => (handleRemove(item))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Delete))
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_icon, {
                style: {"margin-left":"10px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('edit')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Edit))
                ]),
                _: 1
              })
            ])
          ], 2)
        ])
      ], 512)), [
        [_vShow, __props.limit == fileList.value.length]
      ])
    }), 128)),
    _withDirectives(_createVNode(_component_el_upload, {
      ref: (_value, _refs) => {
        _refs['uploadRef'] = _value
      },
      class: "uploader",
      "list-type": "picture-card",
      accept: __props.limitFile?.accept,
      "before-upload": (beforeUpload as any),
      action: host.value,
      data: _unref(uploadParams),
      "file-list": fileList.value,
      limit: __props.limit,
      onSuccess: handleChange
    }, {
      tip: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tip")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([{'active':__props.rotate}])
        }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('请上传图片')), 1)
        ], 2)
      ]),
      _: 3
    }, 8, ["accept", "before-upload", "action", "data", "file-list", "limit"]), [
      [_vShow, __props.limit != fileList.value.length]
    ])
  ]))
}
}

})